export function isAdminRoute() {
    return (window.location.hostname.includes("ops") || window.location.port === "3004");
}
